
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import { Property } from '@/store/prescription/prescriptionDefinition';
	import InfoModal from '@/components/InfoModal.vue';
	import { reaction, IReactionDisposer } from 'mobx';
	import Modal from '@/components/Modal.vue';
	import CloseSVG from '@/components/CloseSVG.vue';
	import Loading from '@/components/Loading.vue';

	@Observer
	@Component({
		components: { Modal, CloseSVG, Loading }
	})
	export default class LeroyModal extends Vue {
		private visualizerNode!: HTMLDivElement;
		isResults = false;
		maskLoading = false;

		mounted() {
			this.visualizerNode = this.$refs['leroyModalNest'] as HTMLDivElement;
			this.$state.leroy.leroyManager.setVisualizerNode(this.visualizerNode);
		}

		unmounted() {
			this.$state.leroy.leroyManager.setVisualizerNode();
		}

		@Watch('$route', { immediate: true, deep: true })
		onNavigation(val: any) {
			this.isResults = val.name === 'Results';
		}

		close() {
			this.$state.leroy.modalVisible = false;
			this.maskLoading = false;
		}

		iframeClick(e) {
			if (this.isResults) {
				e.preventDefault();
			}
		}

		loading() {
			return !this.$state.leroy.sessionState.newSceneInitialized || !this.$state.engine.store.chosenStore;
		}
	}
